import { useState } from 'react'
import { BookOpen, ChevronDown, ChevronUp, Download, RotateCcw, ShoppingBasket, Trash2, X } from 'lucide-react'
import { kindById } from '../lib/canvas'

function CompileModal({ count, onClose, onCompile }) {
  const [title, setTitle] = useState('')
  function submit() {
    if (!title.trim()) return
    onCompile(title.trim())
  }
  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="history-modal" onClick={(event) => event.stopPropagation()}>
        <header><div><h3>汇总成文</h3><p>收纳箱里的 {count} 张卡片将转化为一本书，进入图书馆。</p></div><button className="icon-button" onClick={onClose} aria-label="关闭"><X size={18} /></button></header>
        <div className="card-editor-body">
          <label><span>书名</span><input className="text-input" value={title} placeholder="给这本书起个名字…" aria-label="书名" onChange={(event) => setTitle(event.target.value)} /></label>
          <div className="library-actions">
            <button className="btn btn--ghost" onClick={onClose}>取消</button>
            <button className="btn btn--ink" onClick={submit}><BookOpen size={14} /> 成书入馆</button>
          </div>
        </div>
      </div>
    </div>
  )
}

export function CollectPanel({ canvas, onCompile, onUncollect, onReorder, notify }) {
  const [compiling, setCompiling] = useState(false)
  const collected = (canvas.cards || []).filter((card) => card.status === 'collected').sort((a, b) => (a.order || 0) - (b.order || 0))
  return (
    <div className="box-panel">
      <div className="box-panel__head"><BookMarked size={16} /><h2>收纳箱</h2><em>想成文的卡片放这里；它们同时留在画板上。</em></div>
      {collected.length ? (
        <div className="box-panel__cards">
          {collected.map((card, index) => (
            <div className="box-card" key={card.id}>
              <span className="box-card__kind" style={{ background: card.color }}>{kindById(card.kind).label}</span>
              <div><strong>{index + 1}. {card.title || '未命名卡片'}</strong><p>{card.content ? card.content.slice(0, 60) : ''}</p></div>
              <button className="mini-text-btn" onClick={() => onReorder(index, index - 1)} disabled={index === 0} aria-label="上移"><ChevronUp size={12} /></button>
              <button className="mini-text-btn" onClick={() => onReorder(index, index + 1)} disabled={index === collected.length - 1} aria-label="下移"><ChevronDown size={12} /></button>
              <button className="mini-text-btn" onClick={() => onUncollect(card.id)} aria-label="移出收纳箱">移出</button>
            </div>
          ))}
        </div>
      ) : <p className="box-panel__empty">画板上点卡片右下角「收纳」即可放进这里。</p>}
      <div className="box-panel__foot">
        <button className="btn btn--ink" disabled={!collected.length} onClick={() => setCompiling(true)} aria-label="汇总成文"><BookOpen size={14} /> 汇总成文（{collected.length}）</button>
      </div>
      {compiling ? <CompileModal count={collected.length} onClose={() => setCompiling(false)} onCompile={(title) => { setCompiling(false); onCompile(title) }} /> : null}
    </div>
  )
}


export function ShelfPanel({ canvas, onCompile, onUncollect, onReorder, onSplitBook, notify }) {
  const [compiling, setCompiling] = useState(false)
  const [openBookId, setOpenBookId] = useState(null)
  const collected = (canvas.cards || []).filter((card) => card.status === 'collected').sort((a, b) => (a.order || 0) - (b.order || 0))
  const books = canvas.books || []
  const openBook = books.find((book) => book.id === openBookId)
  return (
    <div className="box-panel">
      <div className="box-panel__head"><ShoppingBasket size={18} /><h2>收纳 · 图书馆</h2><em>未成书的是收纳筐，成书进图书馆，同一个书架。</em></div>
      <section className="shelf-section">
        <h3><ShoppingBasket size={15} /> 收纳筐 · 未成书 <em>{collected.length}</em></h3>
        {collected.length ? (
          <div className="box-panel__cards">
            {collected.map((card, index) => (
              <div className="box-card" key={card.id}>
                <span className="box-card__kind" style={{ background: card.color }}><ShoppingBasket size={11} /> {kindById(card.kind).label}</span>
                <div><strong>{index + 1}. {card.title || '未命名卡片'}</strong><p>{card.content ? card.content.slice(0, 60) : ''}</p></div>
                <button className="mini-text-btn" onClick={() => onReorder(index, index - 1)} disabled={index === 0} aria-label="上移"><ChevronUp size={12} /></button>
                <button className="mini-text-btn" onClick={() => onReorder(index, index + 1)} disabled={index === collected.length - 1} aria-label="下移"><ChevronDown size={12} /></button>
                <button className="mini-text-btn" onClick={() => onUncollect(card.id)} aria-label="移出收纳箱">移出</button>
              </div>
            ))}
          </div>
        ) : <p className="box-panel__empty">画板上点卡片右下角「收纳」即可放进收纳筐。</p>}
        <div className="box-panel__foot">
          <button className="btn btn--ink" disabled={!collected.length} onClick={() => setCompiling(true)} aria-label="汇总成文"><BookOpen size={14} /> 汇总成文（{collected.length}）</button>
        </div>
      </section>
      <section className="shelf-section">
        <h3><BookOpen size={15} /> 图书馆 · 成书 <em>{books.length}</em></h3>
        {books.length ? (
          <div className="box-panel__cards">
            {books.map((book) => (
              <div className="box-card box-card--book" key={book.id} onClick={() => setOpenBookId(book.id)} role="button" tabIndex={0}>
                <span className="box-card__kind box-card__kind--book">📖</span>
                <div><strong>《{book.title}》</strong><p>{(book.cards || []).length} 张卡片 · {new Date(book.compiledAt || Date.now()).toLocaleDateString('zh-CN')}</p></div>
              </div>
            ))}
          </div>
        ) : <p className="box-panel__empty">还没有成书。把卡片收进收纳筐，再点「汇总成文」。</p>}
      </section>
      {compiling ? <CompileModal count={collected.length} onClose={() => setCompiling(false)} onCompile={(title) => { setCompiling(false); onCompile(title) }} /> : null}
      {openBook ? <BookModal book={openBook} onClose={() => setOpenBookId(null)} onSplit={() => onSplitBook(openBook.id)} notify={notify} /> : null}
    </div>
  )
}
export function TrashPanel({ canvas, onRestore, onPurge }) {
  const trashed = (canvas.cards || []).filter((card) => card.status === 'trash')
  return (
    <div className="box-panel">
      <div className="box-panel__head"><Trash2 size={16} /><h2>回收箱</h2><em>废弃的卡片放在这里，不显示在画板上。</em></div>
      {trashed.length ? (
        <div className="box-panel__cards">
          {trashed.map((card) => (
            <div className="box-card" key={card.id}>
              <span className="box-card__kind" style={{ background: card.color }}>{kindById(card.kind).label}</span>
              <div><strong>{card.title || '未命名卡片'}</strong><p>{card.content ? card.content.slice(0, 60) : ''}</p></div>
              <button className="mini-text-btn" onClick={() => onRestore(card.id)} aria-label="恢复"><RotateCcw size={12} /> 恢复</button>
              <button className="danger-link" onClick={() => onPurge(card.id)} aria-label="彻底删除"><Trash2 size={12} /></button>
            </div>
          ))}
        </div>
      ) : <p className="box-panel__empty">回收箱是空的。</p>}
    </div>
  )
}

function bookMarkdown(book) {
  return '# ' + (book.title || '未命名') + '\n\n' + (book.cards || []).map((card) => '## ' + (card.title || '未命名卡片') + '\n\n' + (card.content || '')).join('\n\n')
}

function BookModal({ book, onSplit, onClose, notify }) {
  const md = bookMarkdown(book)
  function exportBook() {
    const blob = new Blob([md], { type: 'text/markdown' })
    const url = URL.createObjectURL(blob)
    const anchor = document.createElement('a')
    anchor.href = url
    anchor.download = (book.title || 'book') + '.md'
    document.body.appendChild(anchor)
    anchor.click()
    document.body.removeChild(anchor)
    URL.revokeObjectURL(url)
    notify('文稿已导出，请选择保存位置。')
  }
  function copyBook() {
    if (navigator.clipboard) navigator.clipboard.writeText(md).then(() => notify('已复制全文。'), () => {})
    else notify('复制失败：浏览器不支持。')
  }
  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="history-modal book-modal" onClick={(event) => event.stopPropagation()}>
        <header><div><h3>《{book.title}》</h3><p>{(book.cards || []).length} 张卡片 · {new Date(book.compiledAt || Date.now()).toLocaleString('zh-CN')}</p></div><button className="icon-button" onClick={onClose} aria-label="关闭"><X size={18} /></button></header>
        <pre className="book-markdown">{md}</pre>
        <div className="library-actions" style={{ padding: '12px 20px' }}>
          <button className="btn btn--ghost" onClick={copyBook}>复制全文</button>
          <button className="btn btn--outline" onClick={exportBook}><Download size={13} /> 导出 Markdown</button>
          <button className="btn btn--outline" onClick={() => { onSplit(); onClose() }} aria-label="拆分回画板">拆分回画板</button>
        </div>
      </div>
    </div>
  )
}

export function LibraryPanel({ canvas, onSplitBook, notify }) {
  const [openBookId, setOpenBookId] = useState(null)
  const books = canvas.books || []
  const openBook = books.find((book) => book.id === openBookId)
  return (
    <div className="box-panel">
      <div className="box-panel__head"><BookOpen size={16} /><h2>图书馆</h2><em>收纳箱汇总成文的书会出现在这里。</em></div>
      {books.length ? (
        <div className="box-panel__cards">
          {books.map((book) => (
            <div className="box-card box-card--book" key={book.id} onClick={() => setOpenBookId(book.id)} role="button" tabIndex={0}>
              <span className="box-card__kind">📖</span>
              <div><strong>《{book.title}》</strong><p>{(book.cards || []).length} 张卡片 · {new Date(book.compiledAt || Date.now()).toLocaleDateString('zh-CN')}</p></div>
            </div>
          ))}
        </div>
      ) : <p className="box-panel__empty">还没有成文。把卡片收进收纳箱，再点「汇总成文」。</p>}
      {openBook ? <BookModal book={openBook} onClose={() => setOpenBookId(null)} onSplit={() => onSplitBook(openBook.id)} notify={notify} /> : null}
    </div>
  )
}

